import styled from 'styled-components';
import { datePickerContainerWidth } from '@/app/components/search/components/DatePickers/DatePicker/styled.ts';

export const MonthButtonStyled = styled.div`
  ${({ theme }) => theme.kallisto.mixins.font('Title5')};
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  padding: 0 16px;
  height: 40px;
  line-height: 40px;
  user-select: none;
  text-align: left;
  ${datePickerContainerWidth};

  @media only screen and (min-width: 768px) {
    text-align: center;
    margin-bottom: 18px;
    margin-left: calc((100% - 135px) / 2);
    max-width: 135px;
  }
`;
